import { findIndex } from 'lodash'

const updateDescription = (descriptions, key, update, idField, nameField) => {
  let index
  // updating the descriptions only for edits that are DONE
  if (update && update.status === 'DONE') {
    index = findIndex(descriptions, ['dictionary_key', key])
    if (
      index !== -1 &&
      // in case the new values are already updated,
      // ignoring the update to avoid extra UI rendering
      descriptions[index][idField] !== update.newId
    ) {
      descriptions = [...descriptions]
      if (update.attributeEdited === 'train') {
        descriptions[index][idField] = Boolean(update.newId)
      } else {
        descriptions[index][idField] = update.newId
        descriptions[index][nameField] = update.newName
      }
    }
  }
  return descriptions
}

export default updateDescription
